import { ReactNode } from "react";
export interface IModalDialog{
  children: ReactNode;
  ClassName?:string;
  scrollable?:boolean;
}

function ModalDialog({ children,ClassName,scrollable }: IModalDialog) {
  return (
    <div
      className={`modal-dialog "${ClassName ? ClassName : "modal-dialog-centered "}${scrollable ? "overflow-scroll" : " "}`}
    >
      {children}
    </div>
  );
}
export default ModalDialog;
